var _defs, _rect, _path, _line, _path2, _g, _g2, _g3, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 749.62 465.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b2a1c4;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-width:1.5px;}.cls-1,.cls-3,.cls-4,.cls-6,.cls-7,.cls-8{stroke-linecap:round;}.cls-1,.cls-3,.cls-7{fill:none;}.cls-1,.cls-4{stroke-linejoin:round;}.cls-2,.cls-9,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-2,.cls-9,.cls-3,.cls-6,.cls-8{stroke:#e24473;}.cls-2,.cls-9,.cls-6,.cls-10,.cls-8{fill:#f3cad2;}.cls-11{fill:#4c4c4c;}.cls-4{fill:#8f72ac;stroke:#4b096f;}.cls-12{fill:#333;}.cls-5{fill:#e24473;stroke:#8e2b48;}.cls-13{fill:#e8e4ec;}.cls-7{stroke:#651e33;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 20.86,
    y: 311.12,
    width: 707.9,
    height: 138.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M233.16,292.19s34.58-1.87,36.4-5.77c2.38-5.1,9.89-31.05,18.42-70.28l12.29,.95-7.16,28.92-10.13,60.01-2.02,11.23-16.93-.48-29.69-13.48-1.17-11.1Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.86,
    y1: 311.12,
    x2: 728.76,
    y2: 311.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "03_pelo",
    className: "cls-5",
    d: "M424.34,190.07s32.65-64.57-.64-97.85c0,0-8.62-7.9-19.45-.99,0,0-28.55-16.47-58.92,12.74-.66,.64-1.24,1.39-1.71,2.17-2.66,4.38-13.56,20.18-35.67,27.09-25.8,8.06-36.02,5.73-43.16,23.62,0,0-5.32,10.97,12,20.47s10.36,6.11,10.36,6.11c0,0-16.55-.68-13.82,16.91,0,0,1.12,10.01,11.28,8.09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 497.73,
    y: 122.62,
    width: 58.28,
    height: 102.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 574.27,
    y: 122.62,
    width: 58.28,
    height: 102.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 650.17,
    y: 122.62,
    width: 58.28,
    height: 102.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 472.72,
    y: 100.97,
    width: 256.04,
    height: 145.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 497.73,
    y: 122.62,
    width: 58.28,
    height: 36.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 497.73,
    y1: 123.55,
    x2: 556.01,
    y2: 159.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 497.73,
    y1: 159.03,
    x2: 556.01,
    y2: 122.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 574.27,
    y: 188.88,
    width: 58.28,
    height: 36.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 574.27,
    y1: 188.88,
    x2: 632.55,
    y2: 225.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 574.27,
    y1: 225.29,
    x2: 632.55,
    y2: 188.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 659.47,
    y: 187.39,
    width: 40.02,
    height: 26.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 659.47,
    y1: 188.06,
    x2: 699.48,
    y2: 213.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 659.47,
    y1: 213.68,
    x2: 699.48,
    y2: 187.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 659.47,
    y: 130.23,
    width: 40.02,
    height: 26.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 659.47,
    y1: 130.9,
    x2: 699.48,
    y2: 156.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 659.47,
    y1: 156.53,
    x2: 699.48,
    y2: 130.23
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 507.74,
    y1: 169.66,
    x2: 547.07,
    y2: 169.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 507.74,
    y1: 183.23,
    x2: 547.07,
    y2: 183.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 507.74,
    y1: 196.79,
    x2: 547.07,
    y2: 196.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 507.74,
    y1: 210.36,
    x2: 547.07,
    y2: 210.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 583.75,
    y1: 133.23,
    x2: 623.08,
    y2: 133.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 583.75,
    y1: 145.49,
    x2: 623.08,
    y2: 145.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 583.75,
    y1: 157.74,
    x2: 623.08,
    y2: 157.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 614.79,
    cy: 175.16,
    r: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 658.73,
    y: 164.03,
    width: 40.75,
    height: 12.43,
    rx: 6.22,
    ry: 6.22
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.36,
    y: 155.33,
    width: 70.29,
    height: 63.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.69,
    y1: 171.54,
    x2: 74.5,
    y2: 171.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.69,
    y1: 185.75,
    x2: 74.5,
    y2: 185.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.69,
    y1: 199.95,
    x2: 64.26,
    y2: 199.95
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.47,
    y: 78.18,
    width: 118.28,
    height: 100.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.82,
    y1: 99.63,
    x2: 146.72,
    y2: 99.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.82,
    y1: 114.17,
    x2: 146.72,
    y2: 114.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.82,
    y1: 128.71,
    x2: 146.72,
    y2: 128.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.82,
    y1: 143.25,
    x2: 146.72,
    y2: 143.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.82,
    y1: 157.8,
    x2: 146.72,
    y2: 157.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.43,
    y1: 85.09,
    x2: 153.43,
    y2: 172.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.96,
    y: 96.88,
    width: 53.39,
    height: 36.89
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.87,313.94l-16.48-103.56c-.61-3.8,3.09-6.86,6.71-5.56l115.29,41.4c1.82,.65,3.11,2.29,3.32,4.21l12.54,113.66-118.22-46.23c-1.67-.65-2.87-2.15-3.16-3.92Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "237.58 303.28 308.7 336.25 244.24 364.08 237.58 303.28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.7,216.3l-4.75,19.44,46.09,4.92s9.38-46.98-23.25-60.77l-2.84-.52s-67.3-28.34-84.17-9.71c-11.22,7.91-15.86,22.9-19.33,35.51-5.04,18.32-9.52,36.9-13.72,55.43-3,13.24-8.19,28.93-6.88,42.68,0,0,.12,4.09,1.14,6.99s84.43,.85,84.43,.85c0,0,8.09-15.69,12.12-32.37s9.79-42.14,9.79-42.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.79,214.85c10.07-41.99,46.38-49.56,46.38-49.56l-28.91,51.79-17.48-2.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M428.04,240.12c-4.39,40.36-24.97,93.35-38.81,95.73-16.97,2.93-86.68-7.19-99.63-9.11,0,0-2.78,.25-4.79-1.57-2.13-1.93-3.65-5.98-8.9-7.41-6.05-1.65-3.85-8.35-10.45-9.37-4.6-.71-13.1,2.72-18.49,3.43-2.12,.28-6.46,2.97-7.48,2.39-1.59-.9-1.44-1.87-1.31-2.39,1.87-7.75,13.45-6.76,24.92-8.54,21.88-3.4,94.48,11.89,104.42,7.58,6.59-2.86,16.24-42.79,22.26-74.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M279.25,322.3s1.6-.64,3.4-.79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M262.19,307.83c1.57,3.03,4.68,5.06,7.27,7.41,1.99,1.8,3.78,3.88,6.3,4.98,1.55,.68,3.62,2.06,5.19,2.69s2.46,1.21,4.07,1.8c4.72,1.74,10.01-.58,14.91-2.07,1.93-.59,2.2-1.04,1.02-2.28s-2.43-2.56-3.65-3.84c-2.49-2.61-4.97-5.23-7.46-7.84-.93-.98-1.89-1.98-3.14-2.58-1.17-.57-2.51-.75-3.82-.93-3.47-.47-6.94-.94-10.42-1.4-1.19-.16-2.43-.32-3.6,0-.98,.26-1.84,.83-2.67,1.39-1.33,.9-2.67,1.79-4,2.69Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "03_menique",
    className: "cls-8",
    d: "M290.52,325.2c-3.18,.66-9.3,2.04-14.54,4.3-6.55,2.83-11.35,6.83-12.28,4.18-2.68-7.63,17.94-12.41,17.94-12.41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "03_dedo_anular",
    className: "cls-8",
    d: "M280.49,318.57c-3.54,2.64-8.55,1.65-12.25,3.63-8.04,4.31-13.5,11.45-15.87,10.29-5.47-2.68,3.67-10.97,7.11-13.17,2.92-1.87,9.2-5.13,12.6-5.82,1.3-.26,2.8-.36,4.24-.29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "03_dedo_medio",
    className: "cls-8",
    d: "M271.53,311.48c-3.54,1.7-8.53,.5-11.87,2.3-8.04,4.31-11.42,12.17-15.17,10.98-6.92-2.2,3.43-11.57,6.87-13.77,2.92-1.87,8.88-4.84,12.28-5.53,.88-.18,1.88-.27,2.89-.28"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "03_cabeza"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.25,173.49l10.55,7.01c18.05,8.96,26.52-2.36,29.22-5.08s13.32-35.93,13.32-35.93c-20.51-2.82-29.1-28.22-29.1-28.22-9.61,27.04-23.98,30.02-23.98,30.02-2.1,8.72-24.72,50.13-24.72,50.13,0,0-3.09,16.22,23.42,18.43,0,0,13.54,1.1,15.43-10.48l6.73-15.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M369.37,142.44s19.13-4.02,25.78-30.02c0,0,7.63,26.86,31.87,28.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.84,145.57s4.55,13.41,3.49,17.11c-1.06,3.7-10.42-1.63-10.42-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.17,144.56s-2.55-13.85-12.21-12.04c-3.9,.73-6.87,3.91-7.81,7.76-1.58,6.48-1.6,16.91,14.95,16.46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep03);
export default __webpack_public_path__ + "static/media/step_03.58d87787c321f2042e7cbfa50dbec4a0.svg";
export { ForwardRef as ReactComponent };